import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 导入语言资源
import zhCN from './locales/zh-CN.json';
import enUS from './locales/en-US.json';
import ruRU from './locales/ru-RU.json';

// 语言持久化相关函数
const LANGUAGE_KEY = 'uai_selected_language';

// 获取保存的语言设置
const getSavedLanguage = (): string | null => {
  try {
    return localStorage.getItem(LANGUAGE_KEY);
  } catch (error) {
    console.warn('无法访问localStorage:', error);
    return null;
  }
};

// 保存语言设置
const saveLanguage = (language: string): void => {
  try {
    localStorage.setItem(LANGUAGE_KEY, language);
  } catch (error) {
    console.warn('无法保存语言设置到localStorage:', error);
  }
};

// 获取浏览器默认语言
const getBrowserLanguage = (): string => {
  const browserLang = navigator.language || (navigator as any).userLanguage;
  
  // 将浏览器语言映射到我们支持的语言
  if (browserLang.startsWith('zh')) {
    return 'zh-CN';
  } else if (browserLang.startsWith('ru')) {
    return 'ru-RU';
  } else if (browserLang.startsWith('en')) {
    return 'en-US';
  } else {
    return 'ru-RU'; // 默认俄语
  }
};

// 确定初始语言
const getInitialLanguage = (): string => {
  // 1. 优先使用保存的语言设置
  const savedLanguage = getSavedLanguage();
  if (savedLanguage) {
    return savedLanguage;
  }
  
  // 2. 其次使用浏览器语言
  const browserLanguage = getBrowserLanguage();
  
  // 3. 保存检测到的语言
  saveLanguage(browserLanguage);
  
  return browserLanguage;
};

const resources = {
  'zh-CN': {
    translation: zhCN,
  },
  'en-US': {
    translation: enUS,
  },
  'ru-RU': {
    translation: ruRU,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(), // 使用智能语言检测
    fallbackLng: 'ru-RU', // 备用语言
    
    interpolation: {
      escapeValue: false, // React已经安全处理了XSS
    },
    
    // 调试选项（生产环境应该关闭）
    debug: process.env.NODE_ENV === 'development',
    
    // 语言检测选项
    detection: {
      // 禁用自动检测，使用我们的自定义逻辑
      order: [],
    },
  });

// 监听语言变化并保存到localStorage
i18n.on('languageChanged', (lng: string) => {
  saveLanguage(lng);
  
  // 可选：设置HTML lang属性，有利于SEO和可访问性
  document.documentElement.lang = lng;
});

// 初始设置HTML lang属性
document.documentElement.lang = i18n.language;

export default i18n; 